import type { Card } from '@/types'
import { formatLidForDisplay } from '@/utils/lid'
import './CardCarousel.css'

export type CardType = 'child' | 'sibling' | 'backlink'

interface CardThumbnailProps {
  card: Card
  type: CardType
  onClick: () => void
}

export function CardThumbnail({ card, type, onClick }: CardThumbnailProps) {
  return (
    <button
      className={`carousel-thumbnail carousel-thumbnail--${type}`}
      onClick={onClick}
      title={card.title}
    >
      <span className="carousel-thumbnail__lid">{formatLidForDisplay(card.lid)}</span>
      <span className="carousel-thumbnail__title">{card.title}</span>
    </button>
  )
}

interface CurrentCardMarkerProps {
  lid: string
}

export function CurrentCardMarker({ lid }: CurrentCardMarkerProps) {
  return (
    <div className="carousel-thumbnail carousel-thumbnail--current-marker">
      <span className="carousel-thumbnail__lid">{formatLidForDisplay(lid)}</span>
      <span className="carousel-thumbnail__marker-text">You are here</span>
    </div>
  )
}
